
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.5 20.5a1 1 0 01-1 1h-13a1 1 0 01-1-1V4A3.5 3.5 0 018 .5h8A3.5 3.5 0 0119.5 4v16.5zm-15-14h15m0 9h-15","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14.5 4.5h-5V3a.5.5 0 01.5-.5h4a.5.5 0 01.5.5v1.5zM6.5 18h3m5 0h3m-17-4.5a1 1 0 001 1H2a.5.5 0 00.5-.5V7.5h-1a1 1 0 00-1 1v5zm21 .5a.5.5 0 00.146.354.5.5 0 00.354.146h.5a1 1 0 001-1v-5a1 1 0 00-1-1h-1V14zm-19-6.5h2m15 0h2m-12 14V23a.5.5 0 01-.5.5H7a.5.5 0 01-.5-.5v-1.5m11 0V23a.5.5 0 01-.146.354.5.5 0 01-.354.146h-2a.5.5 0 01-.354-.146A.5.5 0 0114.5 23v-1.5","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    